export default "__VITE_ASSET__DimPzfi7__"